'use client';

import { Button } from '@/components/ui/button';

export function SwitchNumberButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      type="button"
      variant="ghost"
      className="cs-focusable min-h-[var(--cs-touch-min)] w-full"
      onClick={onClick}
    >
      Check a different number
    </Button>
  );
}
